import React from "react";
import { parseCookies } from 'nookies'
import { atom } from "recoil";


const getToken = () => {
    const cookies = parseCookies()
    return cookies.access_token
};

export const userState = atom({
    key: 'user',
    default: getToken()
});